import React from 'react';
import Lottie from 'lottie-react';
import pikkoLogo from '../../../styles/img/logostatic.svg';
import eye from '../../../styles/lottie/eye.json';
import eyeOff from '../../../styles/lottie/eye-off.json';
import PrimaryButton from '../../../components/button/PrimaryButton';
import OtpInput from 'react18-input-otp';
import { notifyError } from '../../../utils/Notify';
import { HOME, NUMBER_SCREEN } from '../../../constants/routes';
import BackButton from '../../../components/button/BackButton';
import { useNavigate } from 'react-router';

export const PhonePasswordSignUp = ({
  valider,
  backFunction,
  handleNewPassword,
  handleNewCheckPassword,
}) => {
  const navigate = useNavigate();
  const [password, setPassword] = React.useState('');
  const [checkPassword, setCheckPassword] = React.useState('');
  const [showPassword, setShowPassword] = React.useState(true);
  const [showCheckPassword, setShowCheckPassword] = React.useState(true);
  const [step, setStep] = React.useState(1);

  const handleTogglePasswordVisibility = () => setShowPassword(!showPassword);
  const handleToggleCheckPasswordVisibility = () =>
    setShowCheckPassword(!showCheckPassword);

  React.useEffect(() => {
    if (step === 1 && password.length === 6) {
      const timer = setTimeout(() => {
        nextStep();
      }, 500);
      return () => clearTimeout(timer);
    } else if (step === 2 && checkPassword.length === 6) {
      const timer = setTimeout(() => {
        if (password === checkPassword) {
          valider();
        } else {
          notifyError('Les mots de passe ne correspondent pas');
          setCheckPassword('');
        }
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [password, checkPassword, step]);

  const onPasswordInputChange = (value) => {
    if (/^\d*$/.test(value) && value.length <= 6) {
      setPassword(value);
      handleNewPassword(value);
    }
  };

  const onCheckPasswordInputChange = (value) => {
    if (/^\d*$/.test(value) && value.length <= 6) {
      setCheckPassword(value);
      handleNewCheckPassword(value);
    }
  };

  const nextStep = () => {
    setStep(2);
  };

  const handleBack = () => {
    if (step === 1) {
      backFunction();
    } else {
      setStep(1);
      setCheckPassword('');
      setPassword('');
      handleNewPassword('');
    }
  };

  return (
    <div className="phonepasswordsignup">
      <BackButton isLogoVisible={true} iconOnly onClick={handleBack} />

      {step === 1 ? (
        <div>
          <h1 className="mt-[2rem] text-left">
            Choisis ton nouveau mot de passe
          </h1>

          <div className="mt-6 mailformpayment">
            <div className="flex flex-col items-center w-full">
              <label className="mt-2 mb-4 text-2xl !text-center flex items-center gap-3 justify-center">
                Mot de passe
                <button
                  className="cursor-pointer"
                  onClick={handleTogglePasswordVisibility}
                >
                  {showPassword ? (
                    <Lottie
                      animationData={eye}
                      loop={false}
                      autoplay={true}
                      style={{ width: '20px', height: '20px' }}
                    />
                  ) : (
                    <Lottie
                      animationData={eyeOff}
                      loop={false}
                      autoplay={true}
                      style={{ width: '20px', height: '20px' }}
                    />
                  )}
                </button>
              </label>

              <OtpInput
                className="OtpInput"
                value={password}
                onChange={onPasswordInputChange}
                separator={<span className="inline-block min-w-3"></span>}
                separateAfter={1}
                numInputs={6}
                isInputNum={true}
                disabled={false}
                shouldAutoFocus={true}
                inputStyle="password-input"
                isInputSecure={showPassword}
                autoComplete={true}
                inputProps={{
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                  type: showPassword ? 'password' : 'text',
                }}
              />
            </div>
          </div>
        </div>
      ) : (
        <div>
          <h1 className="mt-[2rem] text-left">
            Confirme ton nouveau mot de passe
          </h1>

          <div className="mt-6 mailformpayment">
            <div className="flex flex-col items-center w-full">
              <label className="mt-2 mb-4 text-2xl !text-center flex items-center gap-3 justify-center">
                Confirmation du mot de passe
                <button
                  className="cursor-pointer"
                  onClick={handleToggleCheckPasswordVisibility}
                >
                  {showCheckPassword ? (
                    <Lottie
                      animationData={eye}
                      loop={false}
                      autoplay={true}
                      style={{ width: '20px', height: '20px' }}
                    />
                  ) : (
                    <Lottie
                      animationData={eyeOff}
                      loop={false}
                      autoplay={true}
                      style={{ width: '20px', height: '20px' }}
                    />
                  )}
                </button>
              </label>

              <OtpInput
                className="OtpInput"
                value={checkPassword}
                onChange={onCheckPasswordInputChange}
                separator={<span className="inline-block min-w-3"></span>}
                separateAfter={1}
                numInputs={6}
                isInputNum={true}
                disabled={false}
                shouldAutoFocus={true}
                inputStyle="password-input"
                isInputSecure={showCheckPassword}
                autoComplete={true}
                inputProps={{
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                  type: showCheckPassword ? 'password' : 'text',
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
